// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"SimilarProducts_cardContainer__tAb7b","similarProductsTitle":"SimilarProducts_similarProductsTitle__Wcz4a"};